// Builder supports targeting and scheduling of content by creating
// duplicates and limiting their scope. But since we're fetching all published
// Factories, Builder won't apply the targeting rules for us. This is the
// minimum-viable content de-duplication, which is likely good enough for
// index pages. The show pages will fetch content using the `builder.get`
// API, which does apply targeting.
function removeDuplicates(factories) {
  return Object.values(
    factories.reduce((hash, f) => {
      hash[f.data.url] = hash[f.data.url] || f
      return hash
    }, {}),
  )
}

function parseMaybeDate(d) {
  return d == null ? null : new Date(d)
}

function parseFactory(f) {
  return {
    ...f,
    data: {
      ...f.data,
      establishedAt: parseMaybeDate(f.data.establishedAt),
    },
  }
}

export default function factories(state = [], action) {
  switch (action.type) {
    case 'RECEIVE_FACTORIES':
      return removeDuplicates(action.payload.results).map(parseFactory)
    default:
      return state
  }
}
